import * as fp from 'lodash/fp';
import { weekLabel } from '~/types/utilities';
import { format } from 'date-fns';

export default function transformDateRangeToString(
  startTime: Date | null,
  endTime: Date | null,
): string {
  if (!fp.isDate(startTime) || !fp.isDate(endTime)) {
    return '';
  }
  const dateString = format(startTime, 'MM/dd');
  const weekString = weekLabel[startTime.getDay()].label;

  return `${dateString}(${weekString}) ${format(startTime, 'HH:mm')}~${format(endTime, 'HH:mm')}`;
}
